
import { UntypedFormControl } from "@angular/forms";
import { Injectable } from "@angular/core";

import { DeviceService } from "../services/device.service";

@Injectable({
  providedIn: "root"
})
export class ImeiValidator {
  constructor(private deviceService: DeviceService) {}

  validateImei(component: UntypedFormControl) {
    if (!component.value) {
      return { required: { valid: false } };
    } else if (!this.deviceService.checkIMEI(component.value)) {
      return { validateImei: { valid: false } };
    } else {
      return null;
    }
  }
}
